import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Documents from "@/pages/Documents";
import DocumentDetail from "@/pages/DocumentDetail";
import Folders from "@/pages/Folders";
import Upload from "@/pages/Upload";
import AuthCallback from "@/pages/AuthCallback";
import EmailPage from "@/pages/EmailPage";
import SharedFolder from "@/pages/SharedFolder";
import RulesPage from "@/pages/RulesPage";
import AssistantPage from "@/pages/AssistantPage";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AppLayout from "@/components/app/AppLayout";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-sm">Caricamento…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  // Detect Emergent OAuth callback via URL fragment (synchronously)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/s/:token" element={<SharedFolder />} />
      <Route element={<Protected><AppLayout /></Protected>}>
        <Route path="/app" element={<Dashboard />} />
        <Route path="/app/upload" element={<Upload />} />
        <Route path="/app/documenti" element={<Documents />} />
        <Route path="/app/documenti/:id" element={<DocumentDetail />} />
        <Route path="/app/cartelle" element={<Folders />} />
        <Route path="/app/email" element={<EmailPage />} />
        <Route path="/app/regole" element={<RulesPage />} />
        <Route path="/app/chiedi" element={<AssistantPage />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <AppRouter />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
